import React, { memo, Suspense } from 'react'

import Listings from '@/components/Listings/Listings'
import Navigation from '@/components/Navigation/Navigation'

interface Props {}

const ListingsPage: React.FC<Props> = memo(() => {
  return (
    <>
      <Listings />
    </>
  )
})
ListingsPage.displayName = 'ListingsPage'

export default ListingsPage
